import { AttachmentActivity, DropDown, TemplateCategory } from "../Interfaces";
import {
  ActivityType,
  EVENT_ACTIVITY_TYPE,
  EntityType,
} from "us.collection.admin/constants";
import { EntityTypeShortForm , ActivityVersion} from "us.common/constants";
import { EHF_CATEGORY } from "../Constants";
import { trimText } from "us.common/functions";


/**
 * @function
 * @description Check wether the activity type is event or not
 * @param {string} entityType selected entity type
 * @param {string} activityType selected activity type
 * @returns {boolean} activity type is event or not
 */
export const isEventActivityType = (
  entityType: string,
  activityType: string
): boolean => {
  try {
    return (
      (trimText(entityType) == EntityType.INVOICE ||
        trimText(entityType) == EntityType.CASE) &&
      trimText(activityType) == EVENT_ACTIVITY_TYPE?.toLowerCase()
    );
  } catch (error) {
    return false;
  }
};

/**
 * @function
 * @description Get short form workflow type
 * @param {string} entityType selected entity type
 * @returns {string} entity type
 */
export const getWorkflowType = (entityType: string): string => {
  try {
    switch (trimText(entityType)) {
      case EntityType.INVOICE:
        return EntityTypeShortForm.SUB_CASE;
      case EntityType.CASE:
        return EntityTypeShortForm.CASE;
      default:
        return "";
    }
  } catch (error) {
    return "";
  }
};

/**
 * @function
 * @description get template category list options
 * @param {TemplateCategory[]} categories template categories data
 * @returns {DropDown<Number>} category options array
 */
export const getDropDownContent = (
  categories: TemplateCategory[]
): DropDown<Number>[] => {
  const list = [
    {
      label: "",
      value: 0,
      disabled: true,
    },
  ];
  try {
    if (categories.length > 0) {
      categories.map(({ categoryDisplayName, categoryId }: any) =>
        list.push({ label: categoryDisplayName, value: categoryId, disabled: false })
      );
      return list;
    } else return list;
  } catch {
    return list;
  }
};

/**
 * @function
 * @description get category name for given id
 * @param {TemplateCategory[]} categories template categories data
 * @param {number} categoryId template category id
 * @returns {SVGAnimateMotionElementtring} category name
 */
export const getTemplateCategoryName = (
  activities: TemplateCategory[],
  categoryId: number
): String => {
  try {
    if (Array.isArray(activities)) {
      const activity = activities.find(
        (category: TemplateCategory) => category.categoryId == categoryId
      );
      if (activity) {
        return activity.categoryName;
      } else return "";
    } else return "";
  } catch {
    return "";
  }
};


/**
 * @description returns true or false based on is a attachment activity or not
 * @param {string} activityType - activity type
 * @param {TemplateCategory[]} templateCategories - template category data
 * @param {any} values - form values
 * @returns {boolean}
 */
export const isAttachmentActivity = (
  activityType: string,
  templateCategories: TemplateCategory[],
  values: any
): boolean => {
  try {
    const { templateCategoryId , activityVersion } = values;
    return (
      String(activityType).toLocaleUpperCase() == ActivityType.MESSAGE &&
      activityVersion == ActivityVersion.V2 &&
      getTemplateCategoryName(templateCategories, templateCategoryId) ==
        EHF_CATEGORY
    );
  } catch {
    return false;
  }
};
